import { render, staticRenderFns } from "./ForgotPasswordView.vue?vue&type=template&id=78c1318c&scoped=true&"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordView.vue?vue&type=style&index=0&id=78c1318c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c1318c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSpacer,VTextField})
